import { useSelector } from 'react-redux'

import { PartnerType } from '../../types/partner'
import { useUserType } from './useUserType'

type TenantPartnerRootState = {
  tenants?: { selectedTenantId?: string }
  AccountData: Record<PartnerType, { partnerData?: { partnerId?: string } }>
}

export const getTenantPartnerIdFromState = (
  state: TenantPartnerRootState,
  userType: PartnerType = PartnerType.User
): string | undefined => {
  const tenantId = state.tenants?.selectedTenantId
  const partnerDataId = state.AccountData[userType]?.partnerData?.partnerId

  return tenantId || partnerDataId
}

export const useTenantPartnerId = () => {
  const userType = useUserType()
  return useSelector((state: TenantPartnerRootState) =>
    getTenantPartnerIdFromState(state, userType)
  )
}
